<template>
	<div class="assistteachers flex start-v">
		<!-- 搜索框 -->
		<div class="search flex between">
			<input v-model="queryParam" type="text" placeholder="搜索" />
			<img @click="getTeachers" src="@img/icon/ui_search.png" alt />
		</div>

		<div class="list">
			<div v-if="teachers.length===0" class="nodata"></div>
			<div v-for="(item,index) in teachers" :key="index" @click="addParams.teacherId=item.id" class="card flex between">
				<img :src="item.headPortrait||defaultAvatar" alt />
				<div class="info flex around-v">
					<p class="text-ellipsis">{{item.name}}</p>
					<p>联系方式: {{item.phone||'未录入'}}</p>
				</div>
				<input :checked="addParams.teacherId==item.id" type="checkbox" />
			</div>
		</div>

		<div class="footer">
			<button @click="addTeacher" class="btn-full">确定</button>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			a: undefined,
			defaultAvatar: require("@img/avatar_girl.png"),
			queryParam: undefined,
			teachers: [],
			addParams: {
				teamId: undefined,
				teacherId: undefined,
			},
		};
	},

	mounted() {
		this.addParams.teamId = this.$route.query.gradeId;
		this.getTeachers();
	},

	methods: {
		async getTeachers() {
			try {
				let {success,message,result} = await this.$http.get(`h5/teacherTeam/getTeacher?teamId=${this.addParams.teamId}&query=${this.queryParam}`)
				if (!success) throw new Error(message);
				this.teachers = result;
			} catch (error) {
				console.error("getTeachers", error);
			}
		},

		async addTeacher() {
			if(!this.addParams.teacherId) return this.$message('请选择协助教师');
			try {
				let {success,message} = await this.$http.post("h5/teacherTeam/addTeamTeacher",this.addParams)
				if (!success) throw new Error(message);
				this.$message(message)
				this.$router.go(-1);
			} catch (error) {
				this.$message(error?.message);
				console.error("getTeachers", error);
			}
		},
	},
};
</script>

<style scoped lang="less">
.assistteachers {
	height: 100%;
	padding: 17 / @rem 0 80 / @rem;
	.search {
		width: 100%;
		padding: 0 17 / @rem 5 / @rem;
		position: relative;
		input {
			padding: 0 50 / @rem 0 16 / @rem;
			width: 100%;
			height: 42 / @rem;
			font-size: 14 / @rem;
			border-radius: 21 / @rem;
			background-color: #f3f3f3;
			&::placeholder {
				color: rgba(23, 24, 25, 0.2);
			}
		}
		img {
			width: 19 / @rem;
			height: 19 / @rem;
			object-fit: contain;
			position: absolute;
			right: 30 / @rem;
		}
	}

	.list {
		flex: 1;
		width: 100%;
		height: 100%;
		padding: 11 / @rem 17 / @rem;
		overflow-y: auto;
	}

	.card {
		padding: 10 / @rem 11 / @rem;
		box-shadow: 0 3 / @rem 17 / @rem 0 rgba(143, 72, 0, 0.2);
		border-radius: 12 / @rem;
		margin-bottom: 15 / @rem;
		img {
			width: 45 / @rem;
			height: 45 / @rem;
			border-radius: 50%;
		}
		button {
			width: 56 / @rem;
			height: 28 / @rem;
			border-radius: 15 / @rem;
			color: white;
			font-size: 10 / @rem;
			letter-spacing: 1 / @rem;
			font-family: Source Han Sans CN-Medium;
			background-color: rgba(242, 65, 19, 1);
		}
		input[type="checkbox"] {
			-webkit-appearance: none;
			display: inline-block;
			width: 17 / @rem;
			height: 17 / @rem;
			border-radius: 50%;
			border: 1 / @rem solid rgba(31, 30, 29, 0.3);
			&:checked {
				border: 1 / @rem solid rgba(255, 162, 22, 1);
				background-color: rgba(255, 162, 22, 1);
				position: relative;
				&::after {
					content: "";
					display: inline-block;
					position: absolute;
					left: 50%;
					top: 50%;
					margin-left: -4 / @rem;
					margin-top: -4 / @rem;
					width: 9 / @rem;
					height: 7 / @rem;
					background-image: url(~@img/icon/btn_xzzq.png);
					background-size: cover;
					background-repeat: no-repeat;
				}
			}
		}
		.info {
			flex: 1;
			width: 100%;
			height: 100%;
			align-items: flex-start;
			padding: 0 10 / @rem;
			overflow: hidden;
			p {
				width: 100%;
				&:first-child {
					font-size: 14 / @rem;
					font-family: Source Han Sans CN-Medium;
					font-weight: bold;
				}
				&:last-child {
					font-size: 11 / @rem;
					font-family: Source Han Sans CN-Medium;
					font-weight: bold;
					color: rgba(31, 30, 29, 0.3);
				}
			}
		}
	}
}
</style>
